export enum ButtonThemeEnum {
  DEFAULT = "default",
  DEFAULT_INNER = "default-inner",
  ADD = "add",
  ADD_INNER = "add-inner",
  SAVE = "save",
  SAVE_INNER = "save-inner",
  VALIDATE = "validate",
  VALIDATE_INNER = "validate-inner",
  ERROR = "error",
  ERROR_INNER = "error-inner",
  DELETE = "delete",
  DELETE_INNER = "delete-inner",
  CANCEL = "cancel",
  CANCEL_INNER = "cancel-inner",
  WARNING = "warning",
  WARNING_INNER = "warning-inner",
  SUCCESS = "success",
  SUCCESS_INNER = "success-inner",
  SECONDARY_INNER = "secondary-inner",
}
